export const GRANTS = {
  // default Role based permissions
  grant_one: 1,
  grant_two: 2,
  grant_three: 3,
  grant_four: 4,
  grant_five: 5,
  grant_six: 6,
  // sandbox user permissions
  sandbox_manipulateBoard: 101,
  sandbox_manipulateIntegrationKey: 102,
  sandbox_manipulateUser: 103,
  // super user permissions
  super_manipulate_faq: 104,
}

export const SANDBOX_VISITOR_PERMISSIONS_NOT_ALLOWED = [
  GRANTS.sandbox_manipulateBoard,
  GRANTS.sandbox_manipulateUser,
  GRANTS.sandbox_manipulateIntegrationKey,
];

export const SANDBOX_PERMISSIONS_NOT_ALLOWED = [
  GRANTS.sandbox_manipulateUser,
  GRANTS.sandbox_manipulateIntegrationKey,
];

export const SUPER_PERMISSIONS = [
  GRANTS.super_manipulate_faq
];

export const INV_STATUS_TYPES = {
  open: 1,
  accepted: 2,
  canceled: 3,
}